import React, { Component } from 'react';
import ReactDOM from 'react-dom'

import {TimelineLite} from 'gsap'

import '../../node_modules/parallax-js/deploy/parallax.js'

class Character extends Component {

	componentWillAppear(callback){
		// console.log('character component will appear')
		this.animateIn(callback)
	}

	componentDidAppear() {
		// console.log('character component did appear')
	}

	componentWillEnter (callback) {
    // console.log('character component will enter')
    this.animateIn(callback)
  }

  componentDidEnter () {
    // console.log('character component entered')
  }

  componentWillLeave (callback) {
    // console.log('character component will leave')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.to(el, 0, {
      opacity: 0,
    })
  }

  componentDidLeave () {
    // console.log('character component left')
  }

  animateIn(callback) {
  	const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })
    let text = el.querySelector('.bio-copy')
    let image = el.querySelector('.character-image')

    console.log(text)

    tween.set([el, text, image], {
      opacity: 0
    })
    .to(el, 1.2, {
      opacity: 1
    }, 0.4)
    .to(image, 0.8, {
      opacity: 1
    }, "-=.4")
    .to(text, 0.8, {
      opacity: 1
    }, "-=.2")
  }

  componentDidMount() {
    if (!('WebkitShapeOutside' in document.body.style 
     || 'MozShapeOutside' in document.body.style 
     || 'OShapeOutside' in document.body.style 
     || 'shapeOutside' in document.body.style))
    { 
      setTimeout(function() {
        window.ShapesPolyfill.run({ force: 'force-styles' });
      }, 1000);
    }
  }

  render() {
    return (
      <div className={"character " + this.props.content.id}>
        <img className="character-name" src={this.props.content.name} alt=""/>
        <div className="character-bio">
	        <img className="character-image" src={this.props.content.image} alt=""/>
	        <span className="bio-copy">{this.props.content.bio}</span>
        </div>
      </div>
    );
  }
}

export default Character;


// WEBPACK FOOTER //
// ./src/Components/Character.js